import { FaArrowLeft } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { getMainSiteUrl } from "../../constants/appConfig";
import "./LandingProductCard.css";

function LandingProductCard({ product, image }) {
  const { t } = useTranslation();
  const { title, description, ctaText, ctaLink } = product;
  const ctaLabel = ctaText || t("Request a Quote");
  const footerHref = ctaLink?.href || `${getMainSiteUrl()}/Contact`;
  const footerTarget = ctaLink?.target || "_self";
  const footerRel = footerTarget === "_blank" ? "noopener noreferrer" : undefined;

  const imageUrl = image?.url;
  const imageAlt = image?.alt || title;

  return (
    <article className="landing-product-card">
      <div className="landing-product-card__media">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={imageAlt}
            className="landing-product-card__image"
            width={image?.width || undefined}
            height={image?.height || undefined}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="landing-product-card__placeholder" aria-hidden="true" />
        )}
        <span className="landing-product-card__badge">{t("Product")}</span>
      </div>

      <div className="landing-product-card__content">
        <h3 className="landing-product-card__title">{title}</h3>
        {description ? (
          <p className="landing-product-card__excerpt">{description}</p>
        ) : null}
      </div>

      <div className="landing-product-card__footer">
        <a
          href={footerHref}
          className="landing-product-card__cta"
          target={footerTarget}
          rel={footerRel}
        >
          <span>{ctaLabel}</span>
          <span className="landing-product-card__cta-icon" aria-hidden="true">
            <FaArrowLeft />
          </span>
        </a>
      </div>
    </article>
  );
}

export default LandingProductCard;
